import { z } from 'zod';
/** Anotación privada del director en la ficha del alumno (1..2000 chars). */
export const createStudentNoteSchema = z.object({
    note: z
        .string()
        .trim()
        .min(1, 'La anotación no puede estar vacía')
        .max(2000, 'Máximo 2000 caracteres'),
});
//# sourceMappingURL=student-note.schema.js.map